import store from '@/store'

/**
 * Middleware to check if user has the correct right to access a certain page.
 * Checks are performed based on route meta fields `meta: { guest: true }`.
 * @param {object} router Vue router instance
 */
export default function guestMiddleware(router) {
    router.beforeEach((to, from, next) => {
        // check for the routes that have `guest: true`
        if (to.matched.some(record => record.meta.guest)) {
            if (store.getters['auth/token']) {
                return next({ path: '/' })
            }
            return next()
        }
        return next()
    })
}
